import {FC} from "react";

const ListNav: FC = (props) => {
    return (
        <ul className='divide-y divide-white/5 rounded-md overflow-hidden bg-secondary/20 dark:bg-transparent'>
            {props.children}
        </ul>
    );
};

export default ListNav;